import React from 'react';

import { Box, Chip, Divider, Paper, Stack, Typography } from '@mui/material';

import { SeatLegendItem } from '../charter.types';
import { seatFeatureAliasLegend } from '../common/seatFeatureAliases';

export default function CharterSeatLegend({ legendItems }: { legendItems: Array<SeatLegendItem> }): React.JSX.Element {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap alignItems="center">
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {legendItems.map((item) => (
            <Chip
              key={item.label}
              label={item.label}
              sx={{
                bgcolor: item.color,
                color: item.label === 'Selected' ? 'common.white' : 'text.primary',
                fontWeight: 500,
              }}
            />
          ))}
        </Stack>

        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

        <Box>
          <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', mr: 1.5 }}>
            Features:
          </Typography>
          {seatFeatureAliasLegend.map((feature) => (
            <Typography
              key={feature.alias}
              component="span"
              variant="caption"
              sx={{
                mr: 1.5,
                fontWeight: 500,
              }}
            >
              <Typography
                component="span"
                variant="caption"
                sx={{
                  fontWeight: 700,
                  bgcolor: 'action.hover',
                  px: 0.75,
                  py: 0.25,
                  borderRadius: 0.5,
                  mr: 0.5,
                }}
              >
                {feature.alias}
              </Typography>
              {feature.description}
            </Typography>
          ))}
        </Box>
      </Stack>
    </Paper>
  );
}
